import Api from '@/services/Api'

export default {
  mnetLogin ({ login, password, fingerprint, rememberMe, origin }, nonce) {
    return Api.post('mnet-login', {
      login,
      password,
      fingerprint,
      rememberMe,
      origin
    }, Api.withNonce(nonce))
  },
  twoFactorValidation ({ guid, code, fingerprint }, nonce) {
    return Api.post('two-factor-validation', { guid, code, fingerprint }, Api.withNonce(nonce))
  },
  googleLogin ({ token, fingerprint }) {
    return Api.post('google-login', { token, fingerprint })
  },
  facebookLogin ({ token }) {
    return Api.post('facebook-login', { token })
  },
  spidIdps () {
    return Api.get('spid-idps')
  }
}
